export default __webpack_public_path__ + "static/media/JUEVES.aa6b2f3a.jpeg";